<div *ngIf="items?.length > 0">
  <label class="lum-label">{{ label }}</label>
  <lum-filter-multiselect-chips
    [selectedOptions]="value"
    [placeholder]="placeholder"
    [options]="items"
    (selectOptionEvent)="onSelectedChangeEvent($event)"
  ></lum-filter-multiselect-chips>
</div>
